var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5360_12701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 4.78779C3 4.07566 3.59175 3.49854 4.32187 3.49854H19.6781C20.4082 3.49854 21 4.07566 21 4.78779V20.2093C21 20.9214 20.4082 21.4985 19.6781 21.4985H4.32187C3.59175 21.4985 3 20.9214 3 20.2093V4.78779ZM8.56087 18.5668V10.4387H5.85975V18.5668H8.56087ZM7.21088 9.32829C8.1525 9.32829 8.73862 8.70504 8.73862 7.92428C8.72175 7.12666 8.15363 6.52029 7.22888 6.52029C6.30413 6.52029 5.7 7.12779 5.7 7.92428C5.7 8.70504 6.28612 9.32829 7.19287 9.32829H7.21088ZM12.7324 18.5668V14.0274C12.7324 13.7844 12.7504 13.5414 12.8224 13.3682C13.017 12.8833 13.4614 12.3804 14.2084 12.3804C15.186 12.3804 15.5764 13.1252 15.5764 14.2187V18.5668H18.2775V13.9048C18.2775 11.4073 16.9455 10.2463 15.168 10.2463C13.7347 10.2463 13.0924 11.0338 12.7324 11.5884V11.6165H12.7144L12.7324 11.5884V10.4387H10.0324C10.0661 11.2014 10.0324 18.5668 10.0324 18.5668H12.7324Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5360_12701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3.49854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.3794898362f6711449f90deb0ed80e89.svg";
export { ForwardRef as ReactComponent };